/**
 * Downloads the transcript text as a file
 * @param text - The transcript text to download
 * @param fileName - Optional file name (defaults to 'transcript.txt')
 */
export const downloadTranscript = (text: string, fileName: string = 'transcript.txt') => {
  // Create a blob with the transcript text
  const blob = new Blob([text], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  
  // Create temporary link and trigger download
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  
  // Cleanup
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

/**
 * Validates media file type and size
 * @param file - The file to validate
 * @param maxSizeMB - Maximum file size in MB
 * @returns Error message if invalid, null if valid
 */
export const validateMediaFile = (file: File, maxSizeMB: number = 20) => {
  if (file.size > maxSizeMB * 1024 * 1024) {
    return `File exceeds the ${maxSizeMB} MB size limit.`;
  }

  const fileType = file.type.split('/')[0];
  if (!['video', 'audio'].includes(fileType)) {
    return 'File must be a video or audio file.';
  }

  return null;
};

/**
 * Validates file size
 * @param file - The file to validate
 * @param maxSizeMB - Maximum allowed size in MB
 * @returns Error message if invalid, null if valid
 */
export const validateFileSize = (file: File, maxSizeMB: number) => {
    if (file.size > maxSizeMB * 1024 * 1024) {
      return `File exceeds the ${maxSizeMB} MB size limit.`;
    }
    return null;
  };

/**
 * Checks if a URL is a valid YouTube URL
 * @param url - The URL to check
 * @returns boolean indicating if URL is a YouTube URL
 */
export const isYouTubeUrl = (url: string): boolean => {
  const youtubeRegex = /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/;
  return youtubeRegex.test(url);
}; 